/* import __COLOCATED_TEMPLATE__ from './related-articles.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();